module.exports = __webpack_public_path__ + "img/img／2 (1).536aebe4.png";